import { render } from "./TimeoutView.vue?vue&type=template&id=ebda33e8&scoped=true"
import script from "./TimeoutView.vue?vue&type=script&lang=js"
export * from "./TimeoutView.vue?vue&type=script&lang=js"

import "./TimeoutView.vue?vue&type=style&index=0&id=ebda33e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebda33e8"]])

export default __exports__